import React, { Component, Fragment } from 'react'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import './styles.sass'
import API from '../../api'
import cloneDeep from 'lodash/cloneDeep'
import { isValidEmail } from '../../utils'
import PhoneInput from '../forms/PhoneInput'
import DateFormat from '../helpers/DateFormat'
import GroupTripPackages from '../group-trips/GroupTripPackages'

const msg = defineMessages({
  placeholderPhone: {
    id: 'placeholder.phone',
    defaultMessage: 'Enter phone number',
  },
  placeholderTextareaGroup: {
    id: 'placeholder.textareaGroup',
    defaultMessage:
      'Let us know if you would like to stay in a room alone or if some of the guests are non-divers.',
  },
})

const defaultState = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  finished: false,
  submitted: false,
  trip_package_requests: undefined,
  is_newsletter_subscribed: false,
  is_agreed_to_send_data: false,
  errors: {},
}

export const FormItem = function(props) {
  const {
    isRequired,
    hasError,
    component,
    title,
    errorText,
    name,
    value,
    onChange,
  } = props
  return (
    <Fragment>
      <label className={`${hasError ? 'error-field' : ''}`}>
        <strong>
          {title}
          {isRequired ? <span className='asterisk'>*</span> : ''}
        </strong>
        {component ? (
          React.cloneElement(component, { ...props })
        ) : (
          <input
            type='text'
            required
            name={name}
            onChange={onChange}
            value={value}
          />
        )}
        <div className='error-text'>{errorText}</div>
      </label>
    </Fragment>
  )
}

export const getOperatorTypeTitle = (types) => {
  if(!types) {
    return ''
  }

  if(types.length === 1) {
    if(types.indexOf('10') !== -1 || types.indexOf(10) !== -1) {
      return <FormattedMessage id='liveaboard' defaultMessage='Liveaboard' />
    } else if(types.indexOf('20') !== -1 || types.indexOf(20) !== -1) {
      return <FormattedMessage id='dive_resort' defaultMessage='Dive resort' />
    }
  } else if(types.length === 2) {
    return (
      <FormattedMessage
        id='liveaboard_and_resort'
        defaultMessage='Liveaboard and Dive resort'
      />
    )
  }
}

export const setOperatorIconClass = (types) => {
  if((types && types.length > 1) || !types) {
    return 'dive-center-icon'
  }

  if(types.indexOf('10') !== -1 || types.indexOf(10) !== -1) {
    return 'liveaboard-icon'
  } else {
    return 'dive-resort-icon'
  }
}

class GroupBookingPopup extends Component {
  constructor(props) {
    super(props)

    this.state = defaultState
    this.phoneInstance = null
  }

  onChange = (name, value) => {
    this.setState(
      {
        [name]: value,
      },
      () => {
        if(this.state.submitted) {
          this.validate()
        }
      }
    )
  }

  submit = (e) => {
    e.preventDefault()

    this.setState({
      submitted: true,
    })

    if(this.validate()) {
      API('marketplace/group-trip-request/', false, true)
        .post({ ...this.state, groupTrip: this.props.groupTripId })
        .then(() => {
          this.setState({
            ...defaultState,
            finished: true,
          })
        })
    }

    return false
  }

  validate() {
    let errors = {}

    if(
      !this.state.trip_package_requests ||
      (this.state.trip_package_requests &&
        !this.state.trip_package_requests.length)
    ) {
      errors.trip_package_requests = true
    }

    if(!this.state.first_name) {
      errors.first_name = true
    }

    if(!this.state.last_name) {
      errors.last_name = true
    }

    if(!this.state.email) {
      errors.email = true
    } else if(!isValidEmail(this.state.email)) {
      errors.email = true
    }

    if(!this.state.phone) {
      errors.phone = true
    } else if(this.phoneInstance && !this.phoneInstance.isValidNumber()) {
      errors.phone = true
    }

    if(!this.state.is_agreed_to_send_data) {
      errors.is_agreed_to_send_data = true
    }

    this.setState({
      errors,
    })

    return Object.keys(errors).length === 0
  }

  handleClose = () => {
    this.setState(defaultState)
    this.props.closeModal()
  }

  render() {
    const { errors } = this.state
    const { intl, packages, tripInfo, groupTripId, currency } = this.props

    /* eslint-disable no-console */

    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.handleClose}
        ariaHideApp={false}
        className='Modal popup-container'
        overlayClassName='Overlay'
        contentLabel='Booking enquire popup'
      >
        <div className='popup__header'>
          <span className='btn-close' onClick={this.handleClose}>
            &times;
          </span>
        </div>
        <div className='popup__content'>
          {this.state.finished ? (
            <div className='form-popup-content'>
              <p>
                <FormattedMessage
                  id='booking_enquire_group.finished'
                  defaultMessage='Thank you for your booking enquiry. We have forwarded it to the the trip organiser who will get back to you as soon as possible.'
                />
              </p>
            </div>
          ) : (
            <Fragment>
              <h3>
                <FormattedMessage
                  id='request_to_book'
                  defaultMessage='Request to book'
                />
              </h3>
              <div className='popup__section'>
                <ul className='group-trip-info'>
                  <li className='trip-title'>
                    <FormattedMessage
                      id='group_trip'
                      defaultMessage='Group trip'
                    />
                    :&nbsp;
                    {tripInfo.title}
                  </li>
                  <li>
                    <i
                      className={`font-icons ${setOperatorIconClass(
                        tripInfo.operatorTypes
                      )}`}
                    />
                    {tripInfo.operatorTypesName}
                  </li>
                  <li>
                    <i className='font-icons location-icon' />
                    {tripInfo.countryTitle}
                  </li>
                  <li>
                    <i className='font-icons calendar-icon' />
                    <DateFormat
                      date={tripInfo.dateStart}
                      format={
                        tripInfo.dateStart.substr(0, 4) ===
                        tripInfo.dateEnd.substr(0, 4)
                          ? 'DD MMM'
                          : 'DD MMM YYYY'
                      }
                    />{' '}
                    -{' '}
                    <DateFormat date={tripInfo.dateEnd} format='DD MMM YYYY' />,
                    &nbsp;
                    <FormattedMessage
                      id='night_qty'
                      values={{ qty: tripInfo.duration }}
                      defaultMessage='{qty, plural, one {# night} other {# nights}}'
                    />
                  </li>
                  {(tripInfo.groupSizeMin || tripInfo.groupSizeMax) && (
                    <li>
                      <i className='font-icons peoples-icon' />
                      {tripInfo.groupSizeMax === tripInfo.groupSizeMin ? (
                        <FormattedMessage
                          id='people_group_same'
                          values={{
                            max: tripInfo.groupSizeMax || tripInfo.groupSizeMin,
                          }}
                          defaultMessage='{max} people group'
                        />
                      ) : (
                        <FormattedMessage
                          id='people_group'
                          values={{
                            min: tripInfo.groupSizeMin,
                            max: tripInfo.groupSizeMax,
                          }}
                          defaultMessage='{min} - {max} people group'
                        />
                      )}
                    </li>
                  )}
                </ul>
              </div>
              <div className='popup__section'>
                <p className='popup__section__title'>
                  <FormattedMessage
                    id='select_package'
                    defaultMessage='Select package'
                  />
                </p>
                <GroupTripPackages
                  currency={currency}
                  groupTripId={groupTripId}
                  items={cloneDeep(packages)}
                  onChange={(trips) =>
                    this.onChange('trip_package_requests', trips)
                  }
                />
                {errors.trip_package_requests && (
                  <span className='error-message'>
                    <FormattedMessage
                      id='error_package'
                      defaultMessage='Please select package'
                    />
                  </span>
                )}
              </div>
              <div className='popup__section'>
                <p className='popup__section__title'>
                  <FormattedMessage
                    id='main_guest_info'
                    defaultMessage='Main guest information'
                  />
                </p>
                <form
                  name='enquireForm'
                  noValidate='novalidate'
                  onSubmit={this.submit}
                >
                  <div className='form-row'>
                    <div className='form-column'>
                      <FormItem
                        name='first_name'
                        onChange={(e) =>
                          this.onChange('first_name', e.target.value)
                        }
                        isRequired
                        title={
                          <FormattedMessage
                            id='first_name'
                            defaultMessage='First name'
                          />
                        }
                        hasError={errors.first_name}
                        errorText={
                          <FormattedMessage
                            id='required_field'
                            defaultMessage='This field is required!'
                          />
                        }
                        value={this.state.first_name}
                      />
                    </div>
                    <div className='form-column'>
                      <FormItem
                        name='last_name'
                        onChange={(e) =>
                          this.onChange('last_name', e.target.value)
                        }
                        isRequired
                        title={
                          <FormattedMessage
                            id='last_name'
                            defaultMessage='Last name'
                          />
                        }
                        hasError={errors.last_name}
                        errorText={
                          <FormattedMessage
                            id='required_field'
                            defaultMessage='This field is required!'
                          />
                        }
                        value={this.state.last_name}
                      />
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className='form-column'>
                      <FormItem
                        name='email'
                        onChange={(e) => this.onChange('email', e.target.value)}
                        isRequired
                        title={
                          <FormattedMessage
                            id='email'
                            defaultMessage='Email'
                          />
                        }
                        hasError={errors.email}
                        errorText={
                          <FormattedMessage
                            id='required_field'
                            defaultMessage='This field is required!'
                          />
                        }
                        value={this.state.email}
                      />
                    </div>
                    <div className='form-column'>
                      <FormItem
                        name='phone'
                        onChange={(phone) => this.onChange('phone', phone)}
                        isRequired
                        component={
                          <PhoneInput
                            placeholder={intl.formatMessage(
                              msg.placeholderPhone
                            )}
                            getPhoneInstance={(phoneInstance) =>
                              (this.phoneInstance = phoneInstance)
                            }
                          />
                        }
                        title={
                          <FormattedMessage
                            id='phone'
                            defaultMessage='Phone number'
                          />
                        }
                        hasError={errors.phone}
                        errorText={
                          <FormattedMessage
                            id='required_field'
                            defaultMessage='This field is required!'
                          />
                        }
                        value={this.state.phone}
                      />
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className='form-column full-width'>
                      <FormItem
                        name='comments'
                        onChange={(e) =>
                          this.onChange('comments', e.target.value)
                        }
                        component={
                          <textarea
                            placeholder={intl.formatMessage(
                              msg.placeholderTextareaGroup
                            )}
                          />
                        }
                        title={
                          <FormattedMessage
                            id='comments'
                            defaultMessage='Comments'
                          />
                        }
                        value={this.state.comments}
                      />
                    </div>
                  </div>
                  <div className='form-row'>
                    <label className='checkbox-wrap'>
                      <input
                        type='checkbox'
                        onChange={(e) => {
                          this.onChange(
                            'is_newsletter_subscribed',
                            e.target.checked
                          )
                        }}
                        checked={this.state.is_newsletter_subscribed}
                      />
                      <span />
                      <p>
                        <FormattedMessage
                          id='receive_newsletter'
                          defaultMessage='I would like to receive a newsletter about PADI Travel dive destinations, latest deals and marine creatures.'
                        />
                      </p>
                    </label>
                  </div>
                  <div className='form-row'>
                    <label
                      className={`checkbox-wrap ${
                        errors.is_agreed_to_send_data ? 'error-field' : ''
                      }`}
                    >
                      <input
                        type='checkbox'
                        onChange={(e) => {
                          this.onChange(
                            'is_agreed_to_send_data',
                            e.target.checked
                          )
                        }}
                        checked={this.state.is_agreed_to_send_data}
                      />
                      <span />
                      <p>
                        <FormattedMessage
                          id='aggree_to_sent_my_data'
                          values={{
                            organiserTitle: tripInfo.organiserTitle,
                          }}
                          defaultMessage='I agreed to have my data sent to {organiserTitle} and wish to have them contact me about this trip*.'
                        />
                      </p>
                    </label>
                  </div>
                  <div className='form-submit-button'>
                    <div className='button-wrapper'>
                      <button
                        className='btn-red'
                        type='submit'
                        onClick={() => console.log(this.state)}
                      >
                        <FormattedMessage
                          id='request_to_book'
                          defaultMessage='Request to book'
                        />
                      </button>
                      <p className='submit-hint'>
                        <FormattedMessage
                          id='not_commiting_to_buy'
                          defaultMessage='You’re not committing to buy'
                        />
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </Fragment>
          )}
        </div>
      </Modal>
    )
  }
}

GroupBookingPopup.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(GroupBookingPopup)
